import { Box, Tooltip } from "@mui/material";

export function NotificationUnreadIndicator({ unread }: { unread: boolean }) {
  return (
    <Tooltip title={unread ? "Unread" : ""}>
      <Box
        component="span"
        aria-label={unread ? "Unread notification" : undefined}
        sx={{
          bgcolor: unread ? "primary.main" : "transparent",
          borderRadius: "50%",
          flexShrink: 0,
          height: 8,
          width: 8,
        }}
      />
    </Tooltip>
  );
}
